"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var BUTTON_UP_CLASS = 'pagesSyucchoKaitoriLp-Strong_ToggleIcon-up';
var BODY_CLOSE_CLASS = 'pagesSyucchoKaitoriLp-Strong_PointBody-close';
var StrongPointController = /** @class */ (function (_super) {
    __extends(StrongPointController, _super);
    function StrongPointController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            if (!_this.pointBodyTarget) {
                return;
            }
            (0, jquery_1.default)(_this.pointBodyTarget).addClass(BODY_CLOSE_CLASS);
        };
        _this.toggle = function () {
            if (!_this.toggleButtonTarget || !_this.pointBodyTarget) {
                return;
            }
            var pointBodyElement = (0, jquery_1.default)(_this.pointBodyTarget);
            var toggleButtonElement = (0, jquery_1.default)(_this.toggleButtonTarget);
            if (pointBodyElement.hasClass(BODY_CLOSE_CLASS)) {
                pointBodyElement.removeClass(BODY_CLOSE_CLASS);
                toggleButtonElement.addClass(BUTTON_UP_CLASS);
            }
            else {
                pointBodyElement.addClass(BODY_CLOSE_CLASS);
                toggleButtonElement.removeClass(BUTTON_UP_CLASS);
            }
        };
        return _this;
    }
    StrongPointController.targets = ['toggleButton', 'pointBody'];
    return StrongPointController;
}(stimulus_1.Controller));
exports.default = StrongPointController;
